import $ from 'jquery'
import YouTubePlayer from 'youtube-player'

function init () {
  $(document).ready(function () {

    let $modal = $('.youtube-frame-js')
    if (!$modal.length) {
      return
    }
    $modal.each(function () {
      appendToBody($(this))
      checkConsentModal($(this))
    })
  })
}

function checkConsentModal ($iFramesModal) {
  let dontShowConsentModal = $iFramesModal.hasClass('no-show')
  if (dontShowConsentModal) {
    let player = createPlayers($iFramesModal)
    $iFramesModal.on('shown.bs.modal', function () {
      player.playVideo()
    })
    return
  }
  let acceptBtn = $iFramesModal.find('.acceptBtn')
  acceptBtn.on('click', function () {
    createPlayers($iFramesModal).playVideo()
  })
}

function createPlayers ($iFramesModal) {
  console.log('CreatePlayer was called ')
  let videoPosition = $iFramesModal.find('[data-video-id]')
  let videoId = videoPosition.attr('data-video-id')
  let args = {
    'host': 'https://www.youtube-nocookie.com',
    'videoId': videoId,
    'playerVars': { 'autoplay': 0, 'controls': 2, 'rel': 0 }
  }
  let player = YouTubePlayer(videoPosition.attr('id'), args)
  let closeBtn = $iFramesModal.find('.btn-close')

  closeBtn.on('click', function () {
    player.stopVideo()
  })
  return player
}

//assurance that modals get displayed correctly
function appendToBody ($iFramesModal) {
  $iFramesModal.appendTo('body')
}

export default {
  init
}
